require('./hiringProductInformationPrecontractualLinks.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

// @components
const { OKLink } = require('commonsComponents/OKLink');

class HiringProductInformationPrecontractualLinks extends React.Component {

    render() {
        const { precontractualLinks, precontractualLinkTarget } = this.props;

        return (
            <div className="hiring-product-information-precontractual-links">
                <div className="hiring-product-information-precontractual-links__primary-url ">
                    <OKLink
                        modifier="editorial"
                        to={precontractualLinks.get('field_contract_link_text')}
                        target={precontractualLinkTarget}
                    >
                        {precontractualLinks.get('field_text_prior_to_file')}
                    </OKLink>
                </div>
            </div>
        );
    }
}

HiringProductInformationPrecontractualLinks.propTypes = {
    precontractualLinks: PropTypes.object.isRequired,
    precontractualLinkTarget: PropTypes.string,
};

HiringProductInformationPrecontractualLinks.defaultProps = {
    precontractualLinkTarget: '_blank'
}

module.exports = HiringProductInformationPrecontractualLinks;
